import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { Header } from "@/components/Header";
import { MobileBottomNav } from "@/components/MobileBottomNav";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full relative">
        {/* Decorative grid lines - full page */}
        <div className="fixed inset-0 opacity-[0.03] pointer-events-none z-0">
          <div 
            className="absolute inset-0"
            style={{ 
              backgroundImage: `
                linear-gradient(hsl(var(--primary)) 1px, transparent 1px),
                linear-gradient(90deg, hsl(var(--primary)) 1px, transparent 1px)
              `,
              backgroundSize: '60px 60px'
            }}
          />
        </div>
        <AppSidebar />
        <div className="flex-1 flex flex-col overflow-hidden">
          <div className="flex-1 overflow-auto">
            <Header showSidebarTrigger />
            <main className="flex-1 pb-16 sm:pb-0">
              {children}
            </main>
          </div>
        </div>
        <MobileBottomNav />
      </div>
    </SidebarProvider>
  );
}

export default Layout;
